import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import ReplayIcon from "@material-ui/icons/Replay";
import { ReactComponent as TenIcon } from "./tenIcon.svg";

interface Props {
  direction: "back" | "forward";
  videoRef: React.MutableRefObject<HTMLVideoElement | null>;
  videoLength: number;
  buttonStyles: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backForwardWrapper: {
      position: "relative",
    },
    tenIcon: {
      position: "absolute",
      top: 6,
      left: 8.5,
    },
    reflect: {
      transform: "scaleX(-1)",
    },
  })
);

const BackForwardButton = ({ direction, videoRef, videoLength, buttonStyles }: Props) => {
  const classes = useStyles();

  const goBackSomeSeconds = (seconds: number) => {
    try {
      if (!videoRef.current) {
        throw new Error("Required video data is missing.");
      }
      const newTime = videoRef.current.currentTime - seconds;
      videoRef.current.currentTime = newTime < 0 ? 0 : newTime;
    } catch (error) {
      console.error(error);
    }
  };

  const goForwardSomeSeconds = (seconds: number) => {
    try {
      if (!videoRef.current) {
        throw new Error("Required video data is missing.");
      }
      const newTime = videoRef.current.currentTime + seconds;
      videoRef.current.currentTime = newTime > videoLength ? videoLength : newTime;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <button
      id="back10"
      className={buttonStyles}
      type="button"
      onClick={() => (direction === "back" ? goBackSomeSeconds(10) : goForwardSomeSeconds(10))}
    >
      <div className={classes.backForwardWrapper}>
        <TenIcon className={classes.tenIcon} />
        <ReplayIcon className={direction === "forward" ? classes.reflect : ""} />
      </div>
    </button>
  );
};

export default BackForwardButton;
